<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <!-- 搜索筛选 -->
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable size="small" filterable
                        @change="getListData">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="统计时间：">
                    <el-date-picker v-model="inputDate" :type="statisticType" :default-value="new Date()"
                        @change="changeDate" :clearable="false"
                        :value-format="statisticType === 'month' ? 'yyyy-MM' : 'yyyy'"
                        :placeholder="statisticType === 'month' ? '选择月' : '选择年'" :editable="false"
                        :format="statisticType === 'month' ? 'yyyy年MM月' : 'yyyy年'" size="small">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="统计类型：">
                    <el-radio-group v-model="statisticType" size="small" @change="handleChangeStatisticType">
                        <el-radio label="month" selected>月统计</el-radio>
                        <el-radio label="year">年统计</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item class="btnList">
                    <el-button v-if="btnPermission.search" size="small" type="primary" icon="el-icon-search" @click="getListData()">搜索</el-button>
                    <el-button v-if="btnPermission.export" size="small" type="primary" icon="el-icon-download" @click="handleExport">导出数据</el-button>
                </el-form-item>
            </el-form>
            <!-- 标题 -->
            <div class="title">
                {{ title }}
            </div>
            <!-- 报表内容 -->
            <div class="reportContent">
                <div v-if="Object.keys(profitInfo).length > 0">
                    <el-row :gutter="12">
                        <!-- 左侧：利润信息和收款信息 -->
                        <el-col :span="10">
                            <!-- 利润信息 -->
                            <el-card class="report-card profit-card">
                                <div slot="header" class="card-header">
                                    <span class="header-title"><i class="el-icon-success"></i> 利润信息</span>
                                </div>
                                <div class="stat-item profit-item no-margin">
                                    <div class="stat-label">利润金额</div>
                                    <div class="stat-value profit-value">¥{{ profitInfo.profitMoney.toFixed(2) || 0 }} 元</div>
                                </div>
                            </el-card>
                            <!-- 收款信息 -->
                            <el-card class="report-card">
                                <div slot="header" class="card-header">
                                    <span class="header-title"><i class="el-icon-money"></i> 收款信息</span>
                                </div>
                                <el-row :gutter="8">
                                    <el-col :span="12">
                                        <div class="stat-item profit-item">
                                            <div class="stat-label">总现金收款额</div>
                                            <div class="stat-value">¥{{ profitInfo.payMoneyCount.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="stat-item profit-item">
                                            <div class="stat-label">会员卡消费金额</div>
                                            <div class="stat-value">¥{{ profitInfo.spendVipMoney.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="stat-item profit-item no-margin">
                                            <div class="stat-label">会员充值金额</div>
                                            <div class="stat-value">¥{{ profitInfo.vipMoney.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="12">
                                        <div class="stat-item profit-item no-margin">
                                            <div class="stat-label">会员赠送金额</div>
                                            <div class="stat-value">¥{{ profitInfo.vipGiftMoney.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                        <!-- 右侧：销售信息和成本信息 -->
                        <el-col :span="14">
                            <!-- 销售信息 -->
                            <el-card class="report-card">
                                <div slot="header" class="card-header">
                                    <span class="header-title"><i class="el-icon-tickets"></i> 销售信息</span>
                                </div>
                                <el-row :gutter="8">
                                    <el-col :span="8">
                                        <div class="stat-item profit-item no-margin">
                                            <div class="stat-label">总销售额</div>
                                            <div class="stat-value">¥{{ profitInfo.salesMoneyCount.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item profit-item no-margin">
                                            <div class="stat-label">当月欠款金额</div>
                                            <div class="stat-value">¥{{ profitInfo.monthQianKuan.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item profit-item no-margin">
                                            <div class="stat-label">总欠款金额</div>
                                            <div class="stat-value">¥{{ profitInfo.qianKuanCount.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-card>
                            <!-- 成本信息 -->
                            <el-card class="report-card">
                                <div slot="header" class="card-header">
                                    <span class="header-title"><i class="el-icon-sold-out"></i> 成本信息</span>
                                    <span class="header-badge">成本小计: ¥{{ profitInfo.totalChengBen.toFixed(2) || 0 }} 元</span>
                                </div>
                                <el-row :gutter="10">
                                    <el-col :span="8">
                                        <div class="stat-item profit-item">
                                            <div class="stat-label">镜片成本总额</div>
                                            <div class="stat-value">¥{{ profitInfo.jingPianChengBenCount.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item profit-item">
                                            <div class="stat-label">申购成本总额</div>
                                            <div class="stat-value">¥{{ profitInfo.productChengBenCount.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item profit-item">
                                            <div class="stat-label">备用金消费</div>
                                            <div class="stat-value">¥{{ profitInfo.beiYongJinMoney.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item profit-item no-margin">
                                            <div class="stat-label">经理报销金额</div>
                                            <div class="stat-value">¥{{ profitInfo.reimbursementMoney.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item profit-item no-margin">
                                            <div class="stat-label">工资总额</div>
                                            <div class="stat-value">¥{{ profitInfo.salaryMoney.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                    <el-col :span="8">
                                        <div class="stat-item profit-item no-margin">
                                            <div class="stat-label">开销总额</div>
                                            <div class="stat-value">¥{{ profitInfo.costMoney.toFixed(2) || 0 }} 元</div>
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-card>
                        </el-col>
                    </el-row>
                </div>
                <div v-else class="empty-data">
                    <el-empty description="暂无数据"></el-empty>
                </div>
            </div>
        </topTab>

    </div>
</template>

<script>
import {
    GetStoreProfitReport,
    ExportStoreProfitDtlList
} from '@/api/productApi.js';
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { downloadFile } from "@/utils/export.js";
export default {
    data() {
        return {
            activeTab: '1',
            tabData: [{
                key: '1',
                value: '门店利润'
            }],
            loading: false, // 显示加载
            formInline: {
                storeKeyId: "",
                year: new Date().getFullYear(),
                month: new Date().getMonth() + 1,
                type: 1
            },
            listData: [],
            statisticType: "month",
            inputDate: new Date(),
            storeList: [],
            profitInfo: {},
            title: "门店利润统计",
            btnPermission: {
                export: false,
                search: false,
            }
        };
    },
    // 注册组件
    components: {

    },
    /**
     * 创建完毕
     */
    created() {
        this.GetOrgInfoListByConfig();
        this.checkBtnPermission();
        this.getListData();
    },
    computed: {},
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
        // 检查按钮权限
        checkBtnPermission() {
            this.btnPermission.export = this.$checkBtnPermission('/storeProfit/index', 'export');
            this.btnPermission.search = this.$checkBtnPermission('/storeProfit/index', 'viewPage');
        },
        changePages() { },
        changeDate(val) {
            var list = val.split('-');
            if (this.statisticType === 'month') {
                this.formInline.year = parseInt(list[0]);
                this.formInline.month = parseInt(list[1]);
            } else {
                this.formInline.year = parseInt(list[0]);
                this.formInline.month = 0;
            }
            this.getListData();
        },
        handleChangeStatisticType(val) {
            if (val === 'month') {
                this.formInline.year = new Date().getFullYear();
                this.formInline.month = new Date().getMonth() + 1;
                this.formInline.type = 1;
            } else {
                this.formInline.year = new Date().getFullYear();
                this.formInline.month = 0;
                this.formInline.type = 2;
            }
            this.getListData();
        },
        // 获取列表
        getListData() {
            if (!this.btnPermission.search) {
                this.$message({
                    type: 'info',
                    message: '您没有权限查询，请联系管理员！',
                });
                return;
            }
            this.loading = true;
            GetStoreProfitReport(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.profitInfo = res.data;
                        this.title = res.data.title;
                    } else {
                        this.$message({
                            type: 'info',
                            message: '暂无数据',
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error('数据加载失败，请稍后再试！');
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        if (res.code == 1) {
                            res.data.forEach((item) => {
                                this.storeList.push({
                                    keyId: item.keyId,
                                    value: item.name + '【' + item.remark2 + '】',
                                });
                            });
                        } else {
                            this.$message.error(res.msg);
                        }
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        // 导出门店收支明细
        handleExport() {
            if (!this.btnPermission.export) {
                this.$message({
                    type: "info",
                    message: "您没有导出权限，请联系管理员！",
                });
                return;
            }
            this.$confirm("确定导出所选筛选条件查询出来的门店收支信息吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                ExportStoreProfitDtlList(this.formInline)
                    .then((res) => {
                        if (res.code === 1) {
                            let fileName = res.data
                                ? res.data.substring(res.data.lastIndexOf("/") + 1)
                                : "门店收支清单.xlsx";
                            downloadFile(res.data, fileName);
                            this.$message({
                                type: "success",
                                message: "导出成功!",
                            });
                            this.getListData();
                        } else {
                            this.$message({
                                type: "info",
                                message: res.msg,
                            });
                        }
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$message.error("导出失败，请稍后再试！");
                    });
            });
        },
    },
};
</script>

<style scoped>
.title {
    font-size: 28px;
    font-weight: 700;
    display: block;
    text-align: center;
    margin-bottom: 16px;
}

.reportContent {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px 12px 30px;
}

.report-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(70, 130, 140, 0.08);
    border: 1px solid rgba(70, 130, 140, 0.1);
    overflow: hidden;
    transition: all 0.3s ease;
    margin-bottom: 12px;
}

.report-card:last-child {
    margin-bottom: 0;
}

.report-card:hover {
    box-shadow: 0 4px 20px rgba(70, 130, 140, 0.15);
    transform: translateY(-1px);
}

.report-card ::v-deep .el-card__header {
    padding: 10px 14px;
    background: linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 100%);
    border-bottom: 1px solid rgba(70, 130, 140, 0.15);
}

.report-card ::v-deep .el-card__body {
    padding: 10px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-title {
    font-size: 15px;
    font-weight: 600;
    color: #2d6a6a;
    display: flex;
    align-items: center;
    gap: 6px;
}

.header-title i {
    font-size: 16px;
    color: #468e8e;
}

.header-badge {
    font-size: 13px;
    font-weight: 600;
    color: #d35400;
    background: #fef3e8;
    padding: 0px 10px;
    border-radius: 4px;
}

.basic-info {
    display: flex;
    gap: 30px;
    padding: 10px 0;
}

.info-item {
    display: flex;
    align-items: center;
}

.info-item .label {
    font-weight: 500;
    color: #5a7a7a;
    margin-right: 5px;
}

.info-item .value {
    color: #303133;
    font-size: 16px;
}

.stat-item {
    padding: 12px;
    background-color: #f0f7f9;
    border-radius: 6px;
    margin-bottom: 8px;
    transition: all 0.3s ease;
}

.stat-item:hover {
    box-shadow: 0 4px 12px rgba(70, 130, 140, 0.15);
    transform: translateY(-2px);
}

.profit-item {
    background: linear-gradient(135deg, #e0f2f1 0%, #b2dfdb 100%);
    border: 1px solid #80cbc4;
    padding: 20px;
    min-height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    transition: all 0.3s ease;
}

.profit-item:hover {
    box-shadow: 0 4px 16px rgba(70, 130, 140, 0.2);
    transform: translateY(-2px);
}

.stat-label {
    font-size: 13px;
    color: #5a7a7a;
    margin-bottom: 6px;
}

.stat-value {
    font-size: 16px;
    font-weight: 600;
    color: #2d5a5a;
}

.profit-card {
    border: 1px solid #4db6ac;
}

.profit-value {
    color: #00897b;
    font-weight: 700;
}

.empty-data {
    text-align: center;
    padding: 50px 0;
    background-color: #fff;
    border-radius: 8px;
}

@media (max-width: 768px) {
    .basic-info {
        flex-direction: column;
        gap: 10px;
    }

    .stat-item {
        margin-bottom: 10px;
    }

    /* 收款信息和利润信息在小屏幕上堆叠显示 */
    .profit-card {
        margin-top: 20px;
    }
}
.no-margin {
    margin: 0;
}
</style>